import React from 'react'
import { useOutletContext } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import EditIcon from '@mui/icons-material/Edit'
import EditOffIcon from '@mui/icons-material/EditOff'
import { useQuery } from '~/client/hooks/cqrpc'

import Link from '~/client/components/Link'
import Timestamp from '~/client/components/Timestamp'
import ErrorMessage from '~/client/components/ErrorMessage'
import AppIcon from '~/client/components/AppIcon'
import UnshareDocumentButton from '~/client/components/UnshareDocumentButton'


export default function ConnectionSharingPage() {
  const { host } = useOutletContext()
  const query = useQuery('documents.getMineForApp', { host: host })
  const documents = query.result || []

  return <div>
    <TableContainer sx={{maxWidth: '75vw'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Data Block Shared</TableCell>
            <TableCell>Data Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
          {documents.map(document => (
            <TableRow
              key={document.id}
            >
              <TableCell sx={{p: 1}}>
                <Link to={`/data/${document.id}`}>
                  {document.name}
                </Link>
              </TableCell>
              <TableCell sx={{p: 1}}>
                {document.type.name}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
}
